import { Link } from "@tanstack/react-router"

import { Button } from "@/components/ui/button"
import BoundlessLogo from "@/svg/boundless/logo.svg?react"
import Illustration404 from "@/svg/illustrations/404.svg?react"

export function NotFoundComponent() {
  return (
    <div className="flex h-full flex-col items-center justify-around space-y-8 p-4">
      <BoundlessLogo className="h-12 w-auto" />
      <Illustration404 className="w-full max-w-md" />
      <div className="text-center">
        <h1 className="text-4xl font-extrabold">Oh No! Error 404</h1>

        <p className="mx-auto mt-4 max-w-md text-balance text-neutral-500">
          Oops! That page seems to have taken a detour. <br />
          Let us guide you back to your destination.
        </p>

        <Link to="/">
          <Button className="mt-6">Back to Homepage</Button>
        </Link>
      </div>
    </div>
  )
}
